import { dataToFormData } from '../../Utils/helper';
import { get, patchImage, post, postImage } from './ApiServices';



const apiLoginRequest = async ({ data }) => {
  let response = await post(`/user/login/`, data);
  return response;
};

const LogoutRequest = async ({ data }) => {
  let response = await post(`/user/logout/`, data);
  return response;
};

const refreshTokenRequest = async (token) => {
  console.log('refreshTokenRequest',token);
  let response = await post(`/token/refresh/`, token);
  return response;
};

const apiSignupRequest = async ({ data }) => {
  let formData = dataToFormData(data)
  let response = await postImage(`/user/signup/`, formData);
  return response;
};
const apiPasswordResetRequest = async ({ email }) => {
  let response = await post(`/account/api/password_reset/`, email);
  return response;
};

const getProfileService = async () => {
  let response = await get(`/user/profile/`);
  return response;
};
const editProfileService = async ({ data }) => {
  let formData = dataToFormData(data);

  let response = await patchImage(`/user/profile/`, formData);
  return response;
};


export const loginServices = {
  apiLoginRequest,
  refreshTokenRequest,
  apiSignupRequest,
  apiPasswordResetRequest,
  LogoutRequest,
  getProfileService,
  editProfileService,

};
